import { logger, type Debug } from "@otto-ec/global-resources/debug";
import { type BeforeErrorState, isTimeoutError } from "@otto-ec/global-resources/ky";

/**
 */
export const createLogger = <TNamespace extends string, TScope extends string>(namespace: TNamespace, scope: TScope): Debug<`benefit.${TNamespace}.${TScope}`> => logger(`benefit.${namespace}.${scope}`);

export const kyTimeoutLoggingHook =
	(logger: Debug, url: string) =>
	({ error }: BeforeErrorState) => {
		if (isTimeoutError(error)) {
			logger.warn(`[fetch] Timeout fetch to ${url}`);
		}
		return error;
	};
